import React from 'react';
import { connect } from "react-redux";
import i18n from "../../../../i18next";
import { AvGroup, AvInput, AvForm } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import { Col, Button } from 'reactstrap';
import { getRestaurantNotes, saveRestaurantNotes, clearRestaurantNotes } from '../../../../actions';

class NotesScreen extends React.Component {

    constructor(props) {
        super(props); 
    
        this.state = {
            restaurantNotes: ''
        }

        this.changeState = this.changeState.bind(this);
        this.saveRestaurantNotes = this.saveRestaurantNotes.bind(this);
    }

    componentDidMount = () => {
        const { id } = this.props.match.params;

        this.props.getRestaurantNotes(id);

        this.setState({
            restaurantNotes: this.props.notes.restaurantNotes
        })
    }

    componentDidUpdate = (prevProps) => {
        if(this.props.notes.restaurantNotes !== prevProps.notes.restaurantNotes) {
            this.setState({
                restaurantNotes: this.props.notes.restaurantNotes
            });
        }
    }

    componentWillUnmount = () => {
        this.props.clearRestaurantNotes();
    }
    
    changeState = ({ target }) => {
        this.setState({ 
            restaurantNotes: target.value
        });
    }

    saveRestaurantNotes() {
        const { id } = this.props.match.params;
        this.props.saveRestaurantNotes(id, {restaurantNotes: this.state.restaurantNotes});
    }

    renderNoteArea = () => { 
    const { inputWrapper, inputArea , saveButton, spaceBetween, inputCounter, colStyle } = styles;
    const notesLength = this.state.restaurantNotes ? this.state.restaurantNotes.length : null;

        return (
            <AvGroup style={inputWrapper}>
                <AvInput style={inputArea} type="textarea" name="restaurantNotes" id="restaurantNotes" className="thinScrollbar" placeholder="Enter notes here"
                    value={this.state.restaurantNotes}
                    onChange={this.changeState}
                    errorMessage={i18n.t('common:validations.errorMsg')}
                    maxLength={1000}
                />
                <div style={inputCounter}>{1000 - notesLength} {i18n.t('screens:restaurantsMainContainer.of')} 1000</div>

                 <Col md={12} style={colStyle}>
                    <Button color="primary" sm={12} style={saveButton} onClick={this.saveRestaurantNotes}>
                        <MaterialIcon icon="save" color="#fff" size={20} /><span style={spaceBetween}>{i18n.t('common:buttons.save')}</span>
                    </Button>
                </Col>
            </AvGroup>
        );
    }

    renderHeader() {
        const { headerStyle, spaceBetween } = styles;

        return (
            <div style={headerStyle}>
                <MaterialIcon icon="menu" color="#0288d1" size={20} />
                <span style={spaceBetween}>{i18n.t('screens:restaurantsMainContainer.notes')}</span>
            </div>
        );
    }

    render() {
        const { containerStyle } = styles;

        return (
            <AvForm style={containerStyle}>
                {this.renderHeader()}
                {this.renderNoteArea()}
            </AvForm>
        );
    }
};

const mapStateToProps = state => {
    return {
        notes: state.restaurantNotes
    }
}

export default connect(mapStateToProps, { getRestaurantNotes, saveRestaurantNotes, clearRestaurantNotes })(NotesScreen);

const styles = { 
    inputWrapper: {
        paddingTop: '10px',
        paddingLeft: '10px',
        paddingRight: '10px'
    },
    inputArea: {
        border: '0',
        backgroundColor: '#fafafa',
        height: '320px'
    },
    saveButton: {
        position: 'absolute',
        float: 'right',
        marginTop: '35px',
        right: '0px'
    },
    spaceBetween: {
        paddingLeft: 4
    },
    headerStyle: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        paddingLeft: 0,
        color: '#0288d1',
        width: 299
    },
    containerStyle: {
        marginLeft: 15,
        marginBottom: 25,
        backgroundColor: '#f2f2f2',
        borderLeft: '1px solid #0288d1',
        padding: '10px 15px 15px',
        width: '100%',
        minHeight: 300
    },
    inputCounter: {
        right: 0,
        fontSize: 12,
        paddingTop: 5
    },
    colStyle: {
        position: 'absolute',
        left: '15px'
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/NotesScreen.js